import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/about/skoda125years/watch-out-im-changing-direction",
  "description": "ВНИМАНИЕ, ПОВОРАЧИВАЮ!",
  "huggerTemplate": "default",
  "keywords": "",
  "name": "ВНИМАНИЕ, ПОВОРАЧИВАЮ!",
  "title": "ВНИМАНИЕ, ПОВОРАЧИВАЮ!"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const QueriedGallery = makeShortcode("QueriedGallery");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="center" horizontalAlign="left" src="/m/watch-out-im-changing-direction.jpg" mobileSrc="/m/watch-out-im-changing-direction-mob.png" mdxType="SimpleMainStage">
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ВНИМАНИЕ, ПОВОРАЧИВАЮ!</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>За последние сто лет значительно изменилась еще одна простая на первый взгляд деталь — указатели поворотов. В музее ŠKODA представлена история указателей поворотов — от первых механических стрелок до современных световых указателей.</p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1929  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> LAURIN & KLEMENT <br /> ŠKODA 110 </b> </p>
    <p>В первых автомобилях указателей поворотов не было. Эту функцию выполнял сам водитель, предупреждая о поворотах движением руки, высунутой из окна автомобиля. Ян Гануш из города Оломоуц считается чехословацким изобретателем стрелочных указателей. В 1922 году он запатентовал стрелочный указатель с кожаными ремешками для водителей. В 1929 году на модели LAURIN & KLEMENT ŠKODA 110 появилась электромагнитная стрелка, управляемая поворотным регулятором, расположенным на передней панели.</p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-1" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1937  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA POPULAR MONTE CARLO </b> </p>
    <p>Спустя несколько лет одна стрелка была заменена системой из двух выдвижных указателей поворота с электромагнитным управлением, по одному для каждой стороны автомобиля. Такие указатели поворотов можно было устанавливать на автомобили LAURIN & KLEMENT, выпущенные ранее, в качестве дополнительного оснащения. С 1939 года в Чехословакии использование указателей поворотов стало обязательным. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-2" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1964  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA OCTAVIA COMBI Type 993 C </b> </p>
    <p>Следующим шагом стала система указателей с электрическими лампами и оранжевыми стеклянными рассеивателями. Первоначально указатели поворотов располагались вне фар. Переключателем служил левый подрулевой рычаг. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-3" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1966  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA 1000 MB </b> </p>
    <p>На модели 1000 MB передние указатели поворотов по-прежнему были отдельными фонарями, но задние уже стали частью задних комбинированных фонарей. Указатели включались особым рычажком, имевшим вид небольшого флажка. С помощью этого же рычажка включался и звуковой сигнал. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-4" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1988  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA 125 L </b> </p>
    <p>Указатели поворотов были впервые установлены рядом с фарами на автомобилях ŠKODA серии 105/120, но они еще не были встроены в блок-фары. Кроме того, на передних крыльях этих автомобилей дополнительно использовались небольшие повторители указателей поворотов с рассеивателями оранжевого цвета. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-5" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  1989  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA FAVORIT 136 L </b> </p>
    <p>FAVORIT — первая модель, в которой указатели поворотов и фары представляли собой единое устройство.  </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-6" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  2009  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA YETI </b> </p>
    <p>Спустя несколько лет с передних крыльев оранжевые указатели поворотов переместились на наружные зеркала заднего вида. Подрулевой рычаг перестал использоваться для подачи звукового сигнала, который уступил место другим функциям — в первую очередь круиз-контролю. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-7" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  2017  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA KODIAQ </b> </p>
    <p>Современные указатели поворотов полностью интегрированы в фары и задние комбинированные фонари, как, например, на ŠKODA KODIAQ. В полностью светодиодных фарах нового поколения в модулях ближнего и дальнего света, а также указателях поворотов используются только светодиоды. </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-8" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
    <DefaultSectionHeading mdxType="DefaultSectionHeading">  2019  </DefaultSectionHeading>
    <DefaultSectionText mdxType="DefaultSectionText">
    <p> <b> ŠKODA SUPERB </b> </p>
    <p>Стандартно все SUPERB оснащаются светодиодными задними фонарями Basis, а наиболее престижные версии можно отличить по полностью светодиодным фонарям High с динамическими указателями поворота в виде бегущей строки. Выглядит эффектно, но важнее другое: такое решение повышает уровень безопасности, делая ваше намерение совершить маневр более очевидным. С-образный, как подкова, контур красной части задних фонарей можно назвать традиционным для марки ŠKODA.   </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="2" tags="skoda125years-watch-9" noPb mdxType="QueriedGallery" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      